import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { changePassword } from "../lib/authApi";
import { useAuth } from "../auth/AuthContext";
import { Key } from "@phosphor-icons/react";
import { ThemeToggle } from "../components/ThemeToggle";

export default function ForceChangePassword() {
  const { t } = useTranslation();
  const { refresh, admin } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (admin && !admin.must_change_password) nav("/settings");
  }, [admin, nav]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError(null);
    if (next.length < 12) { setError(t("ui.force_change_password.err_min_length")); setBusy(false); return; }
    if (next === current) { setError(t("ui.force_change_password.err_must_differ")); setBusy(false); return; }
    try {
      await changePassword(current, next);
      await refresh();
      nav("/settings");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : (d?.message || JSON.stringify(d)));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="force-change-page" className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center px-4 relative">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <form onSubmit={submit} className="border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-8 w-[460px] space-y-4 rounded-2xl shadow-sm">
        <div className="flex items-center gap-2 mb-1">
          <Key size={20} className="text-teal-600 dark:text-teal-400" />
          <div className="text-sm tracking-normal text-teal-700 dark:text-teal-300">{t("ui.force_change_password.title")}</div>
        </div>
        <div className="text-xs text-slate-600 dark:text-slate-300">
          {t("ui.force_change_password.intro")}
        </div>
        <input
          data-testid="force-current"
          type="password"
          placeholder={t("ui.force_change_password.current_placeholder")}
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          className="w-full bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 px-3 py-2 text-sm rounded-xl text-slate-900 dark:text-slate-50"
        />
        <input
          data-testid="force-new"
          type="password"
          placeholder={t("ui.force_change_password.new_placeholder")}
          value={next}
          onChange={(e) => setNext(e.target.value)}
          className="w-full bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 px-3 py-2 text-sm rounded-xl text-slate-900 dark:text-slate-50"
        />
        {error && <div data-testid="force-error" className="text-red-700 dark:text-red-300 text-xs">{error}</div>}
        <button
          data-testid="force-submit"
          disabled={busy}
          className="w-full bg-teal-600 hover:bg-teal-700 disabled:opacity-50 text-white font-semibold py-2 text-sm rounded-xl"
        >
          {busy ? t("ui.force_change_password.busy") : t("ui.force_change_password.submit")}
        </button>
      </form>
    </div>
  );
}
